export default __webpack_public_path__ + "static/media/export.2a687b18.svg";